export default __webpack_public_path__ + "static/portfolio_gallery_19-913aea7ddba589f7fba376e1de1ebfe4.jpg";